import CoordenadasFotoConstant from '@/constants/CoordenadasFotoConstant';
import store from '@/store/index'
import Mutations from '@/store/Mutations';

export const GeoLocationService = {
    obterGeolocalizacao() {
        this.buscarCoordenadas();
        this.monitorarCoordenadas();
    },
    buscarCoordenadas() {
        GeoLocationService.getCurrentPosition()
            .then(coords => {
                const coordenadas = GeoLocationService.montarCoordenadas(coords);
                store.commit(Mutations.DEFINE_COORDENADAS_TEMP, coordenadas);
            })
            .catch(coords => coords)
    },
    utilizarCoordenadasStore() {
        const coordenadas = store.state.coordenadasTemp;
        const coordenadasExpiradas = new Date(coordenadas.dataHorarioExpiracao) < new Date();

        if (coordenadasExpiradas) {
            store.commit(Mutations.DEFINE_COORDENADAS_TEMP, CoordenadasFotoConstant.COORDENADAS);
            return false
        }
        return true;
    },
    monitorarCoordenadas() {
        const intervaloBusca = (parseInt(process.env.VUE_APP_TEMPO_EXPIRACAO_COORDENADAS_EM_SEGUNDOS) || 120) * 1001;
        setInterval(() => {
            if (this.utilizarCoordenadasStore() == false) {
                this.buscarCoordenadas();
            }
        }, intervaloBusca);
    },
    montarCoordenadas(coords) {
        const coordenadas = CoordenadasFotoConstant.COORDENADAS;
        const dataHorarioAtual = new Date();

        const tempoExpiracao = (process.env.VUE_APP_TEMPO_EXPIRACAO_COORDENADAS_EM_SEGUNDOS || 120);
        coordenadas.dataHorarioCoordenadas = dataHorarioAtual;
        coordenadas.dataHorarioExpiracao = new Date(dataHorarioAtual.getTime() + tempoExpiracao * 1000);
        coordenadas.localizacao.latitude = coords.latitude;
        coordenadas.localizacao.longitude = coords.longitude;
        coordenadas.localizacao.accuracy = coords.accuracy;
        coordenadas.localizacao.geolocationStatus = coords.geolocationStatus;

        return coordenadas;
    },

    getCurrentPosition(options = {}) {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject({
                    latitude: 0,
                    longitude: 0,
                    accuracy: 0,
                    geolocationStatus: 'Geolocalização não é suportada pelo seu navegador.'
                });
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                        geolocationStatus: 'OK'
                    });
                },
                (error) => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            reject({
                                latitude: 0,
                                longitude: 0,
                                accuracy: 0,
                                geolocationStatus: 'Permissão para acessar a geolocalização foi negada.'
                            });
                            break;
                        case error.POSITION_UNAVAILABLE:
                            reject({
                                latitude: 0,
                                longitude: 0,
                                accuracy: 0,
                                geolocationStatus: 'Informações sobre a localização não estão disponíveis.'
                            });
                            break;
                        case error.TIMEOUT:
                            reject({
                                latitude: 0,
                                longitude: 0,
                                accuracy: 0,
                                geolocationStatus: 'A solicitação para obter a localização expirou.'
                            });
                            break;
                        default:
                            reject({
                                latitude: 0,
                                longitude: 0,
                                accuracy: 0,
                                geolocationStatus: 'Ocorreu um erro desconhecido ao obter a geolocalização.'
                            });
                    }
                },
                options
            );
        });
    },
};